/** InsCoder WANG.J 2026-09-27 B + Find in Store variant refresh fallback **/
if (!customElements.get('cust-find-in-store')) {
  customElements.define(
    'cust-find-in-store',
    class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();

        document.addEventListener('change', this.#onVariantOptionChange.bind(this), {
          capture: true,
          signal: this.abortController.signal,
        });
        document.addEventListener('click', this.#onRetry.bind(this), {
          signal: this.abortController.signal,
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        window.clearTimeout(this.errorTimer);
      }

      #onVariantOptionChange(event) {
        const option = event.target.closest?.('input[data-option-position], select[data-option-position]');
        const formId = this.getAttribute('form-id');

        if (!option || !formId || option.getAttribute('form') !== formId) {
          return;
        }

        const drawer = document.getElementById(this.getAttribute('drawer-id'));
        drawer?.setAttribute('aria-busy', 'true');
        window.clearTimeout(this.errorTimer);

        this.errorTimer = window.setTimeout(() => {
          if (!this.isConnected) return;

          drawer?.removeAttribute('aria-busy');
          drawer?.querySelector('[data-find-in-store-results]')?.setAttribute('hidden', '');
          drawer?.querySelector('[data-find-in-store-error]')?.removeAttribute('hidden');
        }, 8000);
      }

      #onRetry(event) {
        const retryButton = event.target.closest?.('[data-find-in-store-retry]');
        const drawer = document.getElementById(this.getAttribute('drawer-id'));

        if (!retryButton || !drawer?.contains(retryButton)) return;

        retryButton.disabled = true;
        window.location.reload();
      }
    }
  );
}
/** InsCoder WANG.J 2026-09-27 E - Find in Store variant refresh fallback **/
